import PropTypes from 'prop-types';
import { SplitPane } from 'react-collapse-pane';
import LogoutPage from '../../../auth/components/LogoutPage.jsx';
import { isLogoutPage } from '../../../auth/oauth2Service.js';

const Layout = ({ getComponent, useSwaggerEditorReactModal, useSplashScreen }) => {
  if (isLogoutPage()) {
    return <LogoutPage />;
  }

  const EditorPane = getComponent('EditorPane', true);
  const EditorPreviewPane = getComponent('EditorPreviewPane', true);
  const TopBar = getComponent('TopBar', true);
  const Container = getComponent('Container'); // accessed from swagger-ui`
  const Dropzone = getComponent('Dropzone', true);
  const SplashScreen = getComponent('SplashScreen', true);
  const UrlSpecHandler = getComponent('UrlSpecHandler', true);
  const ref = useSwaggerEditorReactModal();
  const [canDisplaySplashScreen, canDisplayLayout] = useSplashScreen();

  return (
    <div className="swagger-editor__layout" ref={ref}>
      <UrlSpecHandler />
      <SplashScreen isOpen={canDisplaySplashScreen} />
      {canDisplayLayout && (
        <>
          <TopBar />
          <Container className="container">
            <Dropzone>
              <SplitPane split="vertical">
                <EditorPane />
                <EditorPreviewPane />
              </SplitPane>
            </Dropzone>
          </Container>
        </>
      )}
    </div>
  );
};

Layout.propTypes = {
  getComponent: PropTypes.func.isRequired,
  useSwaggerEditorReactModal: PropTypes.func.isRequired,
  useSplashScreen: PropTypes.func.isRequired,
};

export default Layout;
